module.exports = __webpack_public_path__ + "polar.svg";